// Copyright (c) 2024 Deere & Company

import AmountOfUseAccordion from './update-amount-of-use-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    amountOfUseModal: state.tcsm.wip.amountOfUseModal,
    amountOfUseRequestItemToUpdate: state.tcsm.wip.amountOfUseItemToUpdate,
    amountOfUseRequestSearchFilters: state.tcsm.wip.amountOfUseRequestSearchFilters,
    amountOfUseRequests: state.tcsm.wip.amountOfUseView,
    length: state.tcsm.wip.amountOfUseLength,
    selectedDealers: state.tcsm.wip.wipFacets.dealers
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AmountOfUseAccordion);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/update-amount-of-use/index.js